<div class="table-loader">
    test
    <div class="row">
        <ngx-skeleton-loader *ngFor="let i of rows"></ngx-skeleton-loader>
    </div>
    <div class="row">
        <ngx-skeleton-loader  *ngFor="let i of rows" class="loader"></ngx-skeleton-loader>
    </div>
    <div class="row">
        <ngx-skeleton-loader  *ngFor="let i of rows" class="loader"></ngx-skeleton-loader>
    </div>
</div>
